import FolderPaywallContainer from './FolderPaywall.container';
import FolderPaywall from './FolderPaywall';

export default FolderPaywallContainer(FolderPaywall);
